import { render, staticRenderFns } from "./MyContextMenu.vue?vue&type=template&id=788e88a3&scoped=true"
import script from "./MyContextMenu.vue?vue&type=script&lang=js"
export * from "./MyContextMenu.vue?vue&type=script&lang=js"
import style0 from "./MyContextMenu.vue?vue&type=style&index=0&id=788e88a3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788e88a3",
  null
  
)

export default component.exports